import React from "react";
import { TableCell, TableRow } from "@mui/material";
import EmailsTableRow from "./EmailsTableRow";
import EntityListTable from "../../helpers/EntityListTable";

const EmailsTable = ({
  emailsList,
  currentPage,
  onPageButtonClicked,
}) => {
  const displayedEmails = emailsList.slice(0, 10);
  const hasNextPage = emailsList.length === 11;

  return (
    <EntityListTable
      currentPage={currentPage}
      hasNextPage={hasNextPage}
      onPageButtonClicked={onPageButtonClicked}
      tableHeaderComponent={
        <TableRow>
          <TableCell>Email</TableCell>
          <TableCell align="right">Create Date</TableCell>
          <TableCell align="right">Last Modified</TableCell>
        </TableRow>
      }
    >
      {displayedEmails.map(
        (email) => <EmailsTableRow
          key={email.userEmailEntityId}
          email={email}
        />,
      )}
    </EntityListTable>
  );
};

export default EmailsTable;
